// Remove page wrapper / spinner classes, once page has loaded
document.addEventListener('DOMContentLoaded', () => {
  const pageWrapper = document.getElementById('pageWrapper');
  pageWrapper?.classList.remove('fade-out');

  const spinner = document.getElementById('spinner');
  spinner?.classList.remove('spin');
});
